const countryToLanguage = {
  MX: 'es', ES: 'es', AR: 'es', CO: 'es', CL: 'es', PE: 'es', EC: 'es', VE: 'es',
  UY: 'es', PY: 'es', BO: 'es', GT: 'es', HN: 'es', SV: 'es', NI: 'es', CR: 'es',
  PA: 'es', CU: 'es', DO: 'es', PR: 'es',
  US: 'en', GB: 'en', CA: 'en', AU: 'en', NZ: 'en', IE: 'en', ZA: 'en', IN: 'en',
  SG: 'en', PH: 'en', MY: 'en', KE: 'en', NG: 'en', GH: 'en', JM: 'en', TT: 'en',
  BR: 'pt', PT: 'pt', AO: 'pt', MZ: 'pt',
  FR: 'fr', BE: 'fr', SN: 'fr', CI: 'fr', CM: 'fr', CD: 'fr', MG: 'fr', ML: 'fr',
  BF: 'fr', NE: 'fr', TD: 'fr', GN: 'fr', HT: 'fr',
  IT: 'it', SM: 'it', VA: 'it',
  DE: 'de', AT: 'de', LI: 'de', CH: 'de',
};

const SUPPORTED = ['es', 'en', 'pt', 'fr', 'it', 'de'];
const GEO_KEY = 'fluxipay_geo_lang';

const GeoLanguageDetector = {
  name: 'geoDetector',

  lookup() {
    return localStorage.getItem(GEO_KEY) || undefined;
  },

  cacheUserLanguage() {},
};

export function initGeoDetection(i18n) {
  if (localStorage.getItem('i18nextLng')) return;
  if (localStorage.getItem(GEO_KEY)) return;

  fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(3000) })
    .then((res) => res.json())
    .then((data) => {
      const lang = countryToLanguage[data.country_code];
      if (lang && SUPPORTED.includes(lang)) {
        localStorage.setItem(GEO_KEY, lang);
        if (i18n.language !== lang) {
          i18n.changeLanguage(lang);
        }
      }
    })
    .catch(() => {});
}

export default GeoLanguageDetector;
